import { CREATOR_TYPES } from '@/modules/dashboard/api/constants';

export const isAutopilotTreatment = ({ creatorType }) => creatorType === CREATOR_TYPES.AUTOPILOT;
